import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fg } from '@atlaskit/platform-feature-flags';

// Ideally, `SelectOption` should extend `OptionType` provided by `@atlaskit/select`, but
// `OptionType` has a property `[key: string]: any;`, which opens the door for broken code - using
// properties that are not defined.

var _toSelectOption = function toSelectOption(choice) {
  var _choice$children;
  return _objectSpread({
    value: choice.id,
    label: choice.label,
    children: (_choice$children = choice.children) === null || _choice$children === void 0 ? void 0 : _choice$children.map(_toSelectOption)
  }, fg('proforma_asset_fields_show_selected_attributes') ? {
    cmdbObject: choice.cmdbObject
  } : {});
};
export { _toSelectOption as toSelectOption };